import { render } from "./LzPaginator.vue?vue&type=template&id=07cc3d4a"
import script from "./LzPaginator.vue?vue&type=script&lang=js"
export * from "./LzPaginator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__